import { render, staticRenderFns } from "./gamble.vue?vue&type=template&id=5bdfbd90&scoped=true&"
import script from "./gamble.vue?vue&type=script&lang=js&"
export * from "./gamble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdfbd90",
  null
  
)

export default component.exports